angular.module('mercury.modules.time.compliance.payrules')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Time.Compliance.PayRulesList', {
    url: '/pay-rules/list',
    controller: 'TimeCompliancePayRulesListCtrl',
    templateUrl: 'modules/time/compliance/payrules/list.tpl.html'
  });

  // view rule in angular view page
  $stateProvider.state('Time.Compliance.PayRulesView', {
    url: '/pay-rules/view/:id',
    controller: 'TimeCompliancePayRulesViewCtrl',
    templateUrl: 'modules/time/compliance/payrules/view.tpl.html',
    data: {
      menuLinkState: 'Time.Compliance.PayRulesList'
    }
  });

  // React routes below

  $stateProvider.state('Time.Compliance.PayRulesManage', {
    url: '/pay-rules/manage/:id',
    controller: 'ReactCtrl',
    data: {
      menuLinkState: 'Time.Compliance.PayRulesList'
    }
  });

  $stateProvider.state('Time.Compliance.PayRulesCreate', {
    url: '/pay-rules/create-rule/:id',
    controller: 'ReactCtrl',
    data: {
      menuLinkState: 'Time.Compliance.PayRulesList'
    }
  });

  $stateProvider.state('Time.Compliance.PayRulesEdit', {
    url: '/pay-rules/edit-rule/:id/:ruleId',
    controller: 'ReactCtrl',
    data: {
      menuLinkState: 'Time.Compliance.PayRulesList'
    }
  });

  $stateProvider.state('Time.Compliance.PayRulesCopy', {
    url: '/pay-rules/copy-rule/:id/:oldId/:ruleId',
    controller: 'ReactCtrl',
    data: {
      menuLinkState: 'Time.Compliance.PayRulesList'
    }
  });

  // view rule in rule wizard
  $stateProvider.state('Time.Compliance.ViewRule', {
    url: '/pay-rules/view-rule/:id/:ruleId',
    controller: 'ReactCtrl',
    data: {
      menuLinkState: 'Time.Compliance.PayRulesList'
    }
  });

  $stateProvider.state('Time.Compliance.AddPackage', {
    url: '/pay-rules/add-package',
    controller: 'ReactCtrl',
    data: {
      menuLinkState: 'Time.Compliance.PayRulesList'
    }
  });

  $stateProvider.state('Time.Compliance.SetupPackage', {
    url: '/pay-rules/setup-package/:id',
    controller: 'ReactCtrl',
    data: {
      menuLinkState: 'Time.Compliance.PayRulesList'
    }
  });
}]);
